import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import InputTextB from '../../../customComponents/inputTextB';
import { FIELDS_INFO } from '../../../../constants';

const OfflineExamForm = ({
    exam,
    formValidations,
    examTemplates,
    boards,
    classes,
    subjects,
    boardId,
    classId,
    isEditMode,
    onTextChange,
    onDropDownChange,
    onTemplateChange,
    onBoardChange,
    onClassChange,
    onSubjectChange,
}) => {
    return (
        <div className='ma-p20 paper-s1'>
            <div className="grid">
                {/* First Row */}
                <div className="col-4">
                    <p className='ma-label-s2'>Name of the Test<span className='ma-required'>*</span></p>
                    <InputTextB info={FIELDS_INFO.EXAM_NAME} id="kexpT">
                        <InputText
                            value={exam.examName}
                            onChange={(e) => onTextChange('examName', e.target.value)}
                            className='w-full'
                        />
                    </InputTextB>
                    {formValidations && !formValidations.fields['examName'].isValid &&
                        <p className="p-error">{formValidations.fields['examName'].errorMsg}</p>}
                </div>

                <div className="col-4">
                    <p className='ma-label-s2'>Template<span className='ma-required'>*</span></p>
                    <InputTextB info={FIELDS_INFO.TEMPLATE} id="lea2eT">
                        <Dropdown
                            value={exam.templateId}
                            className='w-full'
                            options={examTemplates}
                            optionValue='_id'
                            optionLabel='name'
                            disabled={isEditMode}
                            onChange={(e) => onTemplateChange(e.value)}
                            placeholder="Select Template"
                        />
                    </InputTextB>
                    {formValidations && !formValidations.fields['templateId'].isValid &&
                        <p className="p-error">{formValidations.fields['templateId'].errorMsg}</p>}
                </div>

                <div className="col-4">
                    <p className='ma-label-s2'>Board Name<span className='ma-required'>*</span></p>
                    <InputTextB info={FIELDS_INFO.BOARD_SELECT} id="leeaeT">
                        <Dropdown
                            value={boardId}
                            className='w-full'
                            options={boards}
                            optionLabel="boardName"
                            optionValue="boardId"
                            disabled={isEditMode}
                            onChange={(e) => onBoardChange(e.value)}
                            placeholder="Select Board"
                        />
                    </InputTextB>
                    {formValidations && !formValidations.fields['boardId'].isValid &&
                        <p className="p-error">{formValidations.fields['boardId'].errorMsg}</p>}
                </div>

                {/* Second Row */}
                <div className="col-4">
                    <p className='ma-label-s2'>Class Name<span className='ma-required'>*</span></p>
                    <InputTextB info={FIELDS_INFO.CLASS_SELECT} id="leaaeT">
                        <Dropdown
                            value={classId}
                            options={classes}
                            optionLabel="className"
                            optionValue="classId"
                            className='w-full'
                            disabled={isEditMode}
                            onChange={(e) => onClassChange(e.value)}
                            placeholder="Select Class"
                        />
                    </InputTextB>
                    {formValidations && !formValidations.fields['classId'].isValid &&
                        <p className="p-error">{formValidations.fields['classId'].errorMsg}</p>}
                </div>
            </div>

            {/* Subjects section */}
            {exam.templateId && (
                <div className="subjects-section mt-4">
                    <h3 className="mb-3">Subjects</h3>
                    <div className="grid">
                        {Array.isArray(exam.subjects) ? (
                            exam.subjects.map((subject, index) => (
                                <div className="col-4" key={subject.id || `subject-${index}`}>
                                    <p className='ma-label-s2'>Subject {index + 1}<span className='ma-required'>*</span></p>
                                    <InputTextB info={FIELDS_INFO.SUBJECT_SELECT} id={`subject-${index}`}>
                                        <Dropdown
                                            disabled={isEditMode}
                                            value={subject.subjectId}
                                            options={subjects}
                                            optionLabel='subjectName'
                                            optionValue='subjectId'
                                            className='w-full'
                                            onChange={(e) => onSubjectChange(subject.id, e.value)}
                                            placeholder="Select Subject"
                                        />
                                    </InputTextB>
                                </div>
                            ))
                        ) : (
                            <div className="col-12">
                                <p>No subjects available for this template.</p>
                            </div>
                        )}
                    </div>
                    {formValidations && !formValidations.fields['subjects'].isValid &&
                        <p className="p-error mt-2">{formValidations.fields['subjects'].errorMsg}</p>}
                </div>
            )}
        </div>
    );
};

export default OfflineExamForm;